<input
  #file
  type="file"
  multiple
  accept="{{ allowedFileTypes || '*' }}"
  (change)="onFileInputChanged()"
  [disabled]="disabled"
/>

<fieldset class="file-upload-container" [class.disabled]="disabled">
  <legend *ngIf="label">{{ label }}</legend>
  <div class="placeholder" *ngIf="!isMaxUploads(); else unselectable">
    <button mat-button color="primary" (click)="onBrowseButtonClick()" data-testid="browse-button">
      <mat-icon>cloud_upload</mat-icon>
      Browse
    </button>
    or drag and drop files here
    <div *ngIf="allowedFileExtensions">Supported file type(s): {{ allowedFileExtensions }}</div>
  </div>

  <ng-template #unselectable>
    <div class="placeholder">
      <p>No additional files may be selected</p>
    </div>
  </ng-template>

  <ng-container *ngIf="badFiles.length">
    <mat-list dense>
      <ng-container *ngFor="let file of badFiles; trackBy: trackByIndex">
        <mat-list-item>
          <div class="file">
            <div class="file-name">
              {{ file.file.name }}
            </div>
            <div class="warning-group">
              <div class="warning">
                {{ file.reason.substring(0, file.reason.indexOf('You do not need') + 'You do not need'.length) }}...
              </div>
              <mat-icon class="file-warning custom-mat-icon-1" [matTooltip]="file.reason">error</mat-icon>
            </div>
          </div>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </ng-container>

  <ng-container *ngIf="badFiles.length && files.length">
    <mat-divider></mat-divider>
  </ng-container>

  <ng-container *ngIf="files.length">
    <mat-list dense>
      <ng-container *ngFor="let file of files; trackBy: trackByIndex">
        <mat-list-item>
          <div class="file">
            <div class="file-name" [matTooltip]="file.name">{{ file.name }}</div>
            <div class="file-size">({{ file.size | formatBytes }})</div>
            <div class="spacer"></div>
            <button
              class="delete-button custom-mat-icon-button-1rem"
              mat-icon-button
              (click)="onRemoveButtonClick(file)"
            >
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </ng-container>
</fieldset>
